import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { Storage } from '@ionic/storage';

@Injectable()
export class LocalStorageProvider extends BaseProvider {
    constructor(public ionicStorage: Storage) {
        super();
    }

    public async set(key: string, value: any) {
        try {
            return await this.ionicStorage.set(key, value);
        } catch (err) {
            throw err;
        }
    }

    public async get(key: string) {
        try {
            return await this.ionicStorage.get(key);
        } catch (err) {
            throw err;
        }
    }

    public async remove(key: string) {
        try {
            return await this.ionicStorage.get(key);
        } catch (err) {
            throw err;
        }
    }

    public async clear() {
        try {
            return await this.ionicStorage.clear();
        } catch (err) {
            throw err;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/local-storage.ts